const en = {
  // Navbar
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.cases": "Cases",
  "nav.contact": "Contact",
  "nav.cta": "Free Consult",

  // Hero Carousel
  "hero.slide1.tag": "Professional Digital Solutions Provider",
  "hero.slide1.title": "Build Outstanding Digital Products",
  "hero.slide1.subtitle": "Empower Your Business to Soar",
  "hero.slide1.desc": "From website development to mobile apps, we provide comprehensive tech consulting and maintenance services to help your business stand out in the digital era.",
  "hero.slide1.cta1": "Start a Project",
  "hero.slide1.cta2": "View Cases",
  "hero.slide2.tag": "Website Development Experts",
  "hero.slide2.title": "Beautiful Websites",
  "hero.slide2.subtitle": "Drive Business Growth",
  "hero.slide2.desc": "We craft responsive websites tailored for businesses of all sizes, blending modern design aesthetics with outstanding technical performance.",
  "hero.slide2.cta1": "Our Services",
  "hero.slide2.cta2": "Free Consult",
  "hero.slide3.tag": "Mobile App Development",
  "hero.slide3.title": "Smart Mobile Apps",
  "hero.slide3.subtitle": "Connect Users to the Future",
  "hero.slide3.desc": "Professional iOS & Android development team, accompanying your digital transformation journey from product planning to launch and beyond.",
  "hero.slide3.cta1": "View Cases",
  "hero.slide3.cta2": "Consult Now",

  // Services
  "services.badge": "Our Services",
  "services.title": "Professional Tech Services",
  "services.desc": "We provide comprehensive digital solutions — from concept design to product delivery, every step crafted with precision to help your business thrive.",
  "services.web.title": "Website Development",
  "services.web.desc": "We build responsive corporate websites, e-commerce platforms and web apps tailored to your brand, combining modern design with high performance.",
  "services.web.f1": "Responsive Design",
  "services.web.f2": "SEO Optimization",
  "services.web.f3": "High Performance",
  "services.web.f4": "CMS Integration",
  "services.app.title": "Mobile App Development",
  "services.app.desc": "Professional native and cross-platform iOS & Android app development, from product planning to App Store launch, we are with you every step.",
  "services.app.f1": "iOS & Android",
  "services.app.f2": "Cross-platform",
  "services.app.f3": "UI/UX Design",
  "services.app.f4": "App Store Launch",
  "services.consult.title": "Tech Consulting",
  "services.consult.desc": "Personalized technology strategy consulting to help businesses choose the right tech stack and architecture, reducing risk and accelerating delivery.",
  "services.consult.f1": "Tech Selection",
  "services.consult.f2": "Architecture Design",
  "services.consult.f3": "Digital Strategy",
  "services.consult.f4": "Team Training",
  "services.maintain.title": "Maintenance & Support",
  "services.maintain.desc": "24/7 system monitoring and maintenance, regular security updates and performance optimization to keep your digital products running smoothly.",
  "services.maintain.f1": "24/7 Monitoring",
  "services.maintain.f2": "Security Updates",
  "services.maintain.f3": "Performance Tuning",
  "services.maintain.f4": "Tech Support",
  "services.stat1.num": "150+",
  "services.stat1.label": "Projects Delivered",
  "services.stat2.num": "98%",
  "services.stat2.label": "Client Satisfaction",
  "services.stat3.num": "8+",
  "services.stat3.label": "Years Experience",
  "services.stat4.num": "24/7",
  "services.stat4.label": "Tech Support",

  // Cases
  "cases.modal.view": "View Details",
  "cases.badge": "Case Studies",
  "cases.title": "Featured Cases",
  "cases.desc": "Every project is our commitment to excellence — see how digital products drive real business growth.",
  "cases.cta": "View More Cases",
  "cases.page.title": "All Case Studies",
  "cases.page.desc": "Explore our full portfolio of digital products — from e-commerce platforms to enterprise software, each project reflects our commitment to excellence.",
  "cases.page.filter.all": "All",
  "cases.page.filter.web": "Website",
  "cases.page.filter.app": "Mobile App",
  "cases.page.filter.enterprise": "Enterprise",
  "cases.page.back": "Back to Home",
  "cases.page.cta.title": "Ready to Build Something Great?",
  "cases.page.cta.desc": "Let\'s discuss your project and create the next success story together.",
  "cases.page.cta.btn": "Start a Project",
  "cases.c1.title": "LuxeCart E-commerce Platform",
  "cases.c1.type": "Website Development",
  "cases.c1.desc": "A full-featured e-commerce platform for a luxury fashion brand, supporting multi-language and multi-currency, with monthly GMV exceeding 5 million.",
  "cases.c2.title": "MediConnect Medical App",
  "cases.c2.type": "Mobile App Development",
  "cases.c2.desc": "A smart appointment platform connecting patients and doctors, reaching 100K users in 6 months and awarded Best Medical App of the Year.",
  "cases.c3.title": "FinTrack Finance System",
  "cases.c3.type": "Enterprise Software",
  "cases.c3.desc": "A SaaS financial management platform for SMEs with AI-powered analytics, enabling precise financial control and business insights.",

  // Case modal details
  "cases.c1.client": "LuxeCart Fashion Group",
  "cases.c1.challenge": "The client needed a high-performance e-commerce platform capable of handling peak traffic during major sales events, supporting multi-language and multi-currency transactions across Southeast Asia, while maintaining a premium brand experience.",
  "cases.c1.solution": "We built a headless commerce architecture using React and Shopify, with a custom CDN strategy and edge caching to ensure sub-second load times globally. A bespoke design system was crafted to reflect the luxury brand identity across all touchpoints.",
  "cases.c1.result1": "Monthly GMV exceeded SGD 5 million within 3 months of launch",
  "cases.c1.result2": "Page load time reduced by 65%, bounce rate dropped by 40%",
  "cases.c1.result3": "Supports 8 languages and 12 currencies seamlessly",
  "cases.c1.result4": "Handled 50,000 concurrent users during peak sale events",

  "cases.c2.client": "MediConnect Healthcare",
  "cases.c2.challenge": "Patients faced long wait times and difficulty booking specialist appointments. The client needed a unified platform connecting patients, GPs, and specialists with real-time availability and AI-assisted triage.",
  "cases.c2.solution": "We developed a cross-platform mobile app using React Native and Supabase, integrating an AI symptom checker, real-time slot management, and secure video consultation. The system connects with existing hospital EMR systems via HL7 FHIR APIs.",
  "cases.c2.result1": "100,000 registered users within 6 months of launch",
  "cases.c2.result2": "Average appointment wait time reduced from 3 days to 4 hours",
  "cases.c2.result3": "Awarded Best Medical App of the Year by Singapore HealthTech Awards",
  "cases.c2.result4": "4.8-star rating on both App Store and Google Play",

  "cases.c3.client": "FinTrack Solutions",
  "cases.c3.challenge": "SMEs struggled with fragmented financial data across multiple tools, making it difficult to get real-time insights and comply with local tax regulations. Manual reporting consumed over 20 hours per month per finance team.",
  "cases.c3.solution": "We built a SaaS platform with Vue.js frontend and Python microservices backend, featuring automated bank reconciliation, AI-powered cash flow forecasting, and one-click GST/tax report generation integrated with IRAS.",
  "cases.c3.result1": "Finance reporting time reduced by 85% on average",
  "cases.c3.result2": "Over 2,000 SMEs onboarded within the first year",
  "cases.c3.result3": "AI forecasting accuracy reached 94% for 90-day cash flow predictions",
  "cases.c3.result4": "Fully compliant with Singapore GST and MAS reporting requirements",

  "cases.c4.client": "HomeNest Realty Pte Ltd",
  "cases.c4.challenge": "The agency relied on outdated listing portals with poor UX and no differentiation. They needed a branded platform with advanced search, virtual tours, and mortgage tools to attract high-net-worth buyers.",
  "cases.c4.solution": "We delivered a Next.js platform with server-side rendering for SEO, integrated 3D virtual tour support, an AI-powered property recommendation engine, and a built-in mortgage calculator connected to live bank rates.",
  "cases.c4.result1": "Organic search traffic increased by 220% in 6 months",
  "cases.c4.result2": "Lead conversion rate improved from 1.2% to 4.7%",
  "cases.c4.result3": "Average session duration increased by 3.5 minutes",
  "cases.c4.result4": "Featured in PropertyGuru's Top 10 PropTech Innovations 2024",

  "cases.c5.client": "FitPulse Inc.",
  "cases.c5.challenge": "The fitness market was saturated with generic apps. The client wanted an AI-powered coach that adapts to individual fitness levels, integrates with wearables, and provides real-time form correction using the phone camera.",
  "cases.c5.solution": "We built a Flutter app with on-device ML models for real-time pose estimation, Firebase for real-time sync across devices, and a personalized workout engine that adapts plans based on performance data and recovery metrics.",
  "cases.c5.result1": "50,000 downloads in the first month post-launch",
  "cases.c5.result2": "78% of users reported visible fitness improvements within 8 weeks",
  "cases.c5.result3": "Average daily active usage of 24 minutes per user",
  "cases.c5.result4": "Featured as App of the Day on the App Store in 3 countries",

  "cases.c6.client": "GlobalManu Corp",
  "cases.c6.challenge": "The manufacturer operated across 12 countries with siloed supply chain systems, causing inventory mismatches, delayed shipments, and a 15% logistics cost overrun annually. Real-time visibility was non-existent.",
  "cases.c6.solution": "We architected a unified supply chain platform on AWS with React frontend and Java microservices, featuring real-time IoT tracking, predictive demand forecasting, automated PO generation, and a supplier collaboration portal.",
  "cases.c6.result1": "Logistics costs reduced by 30% in the first year",
  "cases.c6.result2": "On-time delivery accuracy improved from 82% to 99.5%",
  "cases.c6.result3": "Inventory holding costs reduced by 25% through demand forecasting",
  "cases.c6.result4": "Full visibility across 12 countries and 200+ suppliers in real time",

  // Contact
  "contact.badge": "Contact Us",
  "contact.title": "Start Your Digital Journey",
  "contact.desc": "Whatever your ideas or needs, our professional team is ready to consult with you and build outstanding digital products together.",
  "contact.left.title": "Let\'s Create\nSomething Extraordinary",
  "contact.left.desc": "Our professional team is ready to consult with you anytime, accompanying your digital transformation from requirements to delivery.",
  "contact.phone": "+65 9662 8319",
  "contact.whatsapp": "WhatsApp: +65 9662 8319",
  "contact.email": "cs@risephoenixtech.com",
  "contact.address": "Singapore",
  "contact.form.name": "Name",
  "contact.form.name.placeholder": "Your name",
  "contact.form.company": "Company",
  "contact.form.company.placeholder": "Your company",
  "contact.form.email": "Email",
  "contact.form.phone": "Phone",
  "contact.form.phone.placeholder": "+86 138 0000 0000",
  "contact.form.type": "Project Type",
  "contact.form.type.placeholder": "Select project type",
  "contact.form.type.web": "Website Development",
  "contact.form.type.app": "Mobile App Development",
  "contact.form.type.consult": "Tech Consulting",
  "contact.form.type.maintain": "Maintenance & Support",
  "contact.form.type.other": "Other",
  "contact.form.message": "Project Description",
  "contact.form.message.placeholder": "Briefly describe your project requirements, budget range and expected delivery time...",
  "contact.form.submit": "Submit Inquiry",
  "contact.form.submitting": "Submitting...",
  "contact.form.success.title": "Submitted Successfully!",
  "contact.form.success.desc": "Thank you for your inquiry. Our team will contact you within 24 hours.",
  "contact.form.success.again": "Submit Again",
  "contact.form.error": "Submission failed. Please try again or contact us directly.",
  "contact.required": "*",

  // Footer
  "footer.desc": "Focused on software development and digital solutions, providing website development, mobile apps, tech consulting and maintenance services to build high-quality digital products.",
  "footer.services": "Services",
  "footer.service1": "Website Development",
  "footer.service2": "Mobile App Development",
  "footer.service3": "Tech Consulting",
  "footer.service4": "Maintenance & Support",
  "footer.service5": "Digital Transformation",
  "footer.contact": "Contact Us",
  "footer.address": "Singapore",
  "footer.copyright": "© 2025 Rise Phoenix. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.sitemap": "Sitemap",
};

export default en;
